import type { ChartTable, ChartTableCell } from './chartTable';

/** Semicolon opens as columns in Excel for most EU locales (incl. PL). */
const CSV_SEPARATOR = ';';
const CSV_LINE_BREAK = '\r\n';

function escapeCsvCell(cell: ChartTableCell): string {
  if (cell === null) {
    return '';
  }
  const text = String(cell);
  if (/[";\r\n]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

export function toCsv(table: ChartTable): string {
  return [table.headers, ...table.rows]
    .map((row) => row.map(escapeCsvCell).join(CSV_SEPARATOR))
    .join(CSV_LINE_BREAK);
}
